import { TextInput, Textarea, Checkbox, Button, Select, Group, Box, Anchor, PasswordInput, NumberInput, Modal, Grid } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import PhoneInput from 'react-phone-number-input'
import { useForm } from '@mantine/form';
import React, { useEffect, useState } from "react";
import './SignForm.css';
import 'react-phone-number-input/style.css'

export default function SignForm() {
    const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
    
    const fetchData = () => {
        return fetch(window.ENV.REACT_APP_SERVER_URL + "/api/v1/getOffersList")
              .then((response) => response.json())
              .then((data) => setData(data));
      }

    useEffect(() => {
        fetchData();
      },[])
  
    const form = useForm({
        initialValues: {
          username: '',
		  userpassword: '',
          phonenumber: '',
          contract: '',
          publicsshkey: '',
          termsOfService: false,
        },

        validate: {
			username: (value) => value === ''
			  ? 'Please provide username'
			  : (/^[\w.@+-]+$/.test(value) ? (value.length < 150 ? null : 'Username must not exceed 150 characters.') : 'Username provided is not valid.'),
			userpassword: (value) => (/^[A-Za-z0-9!@#$%&*]{5,30}$/.test(value) ? null : 'Password provided is not valid.'),
			phonenumber: (value) => (/^[+].[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(value) ? null : 'Invalid phone number'),
			contract: (value) => value === '' ? 'Please provide the EODC contract number' : null,
			publicsshkey: (value) => value === '' ? 'Please provide public SSH key' : null,
			termsOfService: (value) => value === false && 'Please check this to continue',
        },

    });

    // create form submit handler:
	const formOnSubmit = form.onSubmit(
        (values) => {
			setIsLoading(true);
            console.log(values)
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(values)
            };
            fetch(window.ENV.REACT_APP_SERVER_URL + "/api/v1/updateUser", requestOptions)
                .then((response) => {
					setIsModalOpen(true);
					if (response.ok) {
					  setModalMessage("User updated successfully!");
					} else if (response.status === 403) {
						response.json().then((data) => {
									setModalMessage("The server encoutered an issue during the user update : "+response.status+" : "+data.error || "Error during authentification.");
								});
					} else if (response.status === 404) {
						response.json().then((data) => {
									setModalMessage("The server encoutered an issue during the user update : "+response.status+" : "+data.error || "Error during account verification.");
								});
				    } else {
						setModalMessage("Error updating user.");
					}
				})
				.finally(() => {
				  setIsLoading(false); // Set the isLoading state variable back to false
				});
        },
        // optional, as form.getInputProps() can make inputs display the error themselves:
        (errors) => {
			setIsModalOpen(true);
			setModalMessage("Error updating user.");
			console.error(errors)
		}
      );
	  
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalMessage, setModalMessage] = useState("");

  return (
  <>
    <Box maw={600} mx="auto">
      <form onSubmit={formOnSubmit}>
        <TextInput
          withAsterisk
          label="Username"
          placeholder="Your username"
          {...form.getInputProps('username')}
        />

        <PasswordInput
          withAsterisk
          label="Password"
          placeholder="Your password"
          {...form.getInputProps('userpassword')}
        />
        <Grid grow>
          <Grid.Col span={4}>
             <TextInput
              withAsterisk
              disabled
              label="Phone number"
              placeholder="Your phone number"
              description={
        <>
          Must be in international format.
          <br/>
            Select first your phone country, the enter your national phone number.
        </>
      }
              {...form.getInputProps('phonenumber')}
            />
          </Grid.Col>
          <Grid.Col span={4}>
           <PhoneInput
              withAsterisk
              label="Phone number"
              placeholder="Enter phone number"
              {...form.getInputProps('phonenumber')}
            />
          </Grid.Col>
        </Grid>

        <TextInput
          withAsterisk
          label="EODC contract number"
          placeholder="Your contract number"
          {...form.getInputProps('contract')}
        />

        <Textarea
          placeholder="Your public SSH key"
          label="Public SSH key"
          withAsterisk
          {...form.getInputProps('publicsshkey')}
        />

        <Checkbox
          mt="md"
          label={
        <>
          I accept the{" "}
          <Anchor size="sm" href="https://eodc.eu/latest_tac" target="_blank">
            EODC terms and conditions
          </Anchor>
        </>
      }
          {...form.getInputProps('termsOfService', { type: 'checkbox' })}
        />

        <Group position="center" mt="md">
          <Button className="submitSignFormButton" type="submit" disabled={isLoading} loading={isLoading} >Update WEkEO Account</Button>
        </Group>
      </form>
    </Box>
	<Modal
	  opened={isModalOpen}
	  onClose={() => setIsModalOpen(false)}
	  title="Update User Account"
	  size="sm"
	>
	  {modalMessage}
	  <br/>
	  <br/>
		<Button className="SignModalButton" onClick={() => setIsModalOpen(false)}>Close</Button>
	</Modal>
</>

  );
}